// extracted by mini-css-extract-plugin
export default {"input_container":"InputOtp_input_container__3h2ic","otp_input":"InputOtp_otp_input__9MfOh"};